export const gradients = {
    imageBackground: 'linear(270deg, #E6E5EA, #EEEEEE)',
};
